import { render, staticRenderFns } from "./backgroundsetting.vue?vue&type=template&id=62ff24de"
import script from "./backgroundsetting.vue?vue&type=script&lang=js"
export * from "./backgroundsetting.vue?vue&type=script&lang=js"
import style0 from "./backgroundsetting.vue?vue&type=style&index=0&id=62ff24de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports